import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';

interface ClientPhotoLightboxProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  src: string;
  name: string;
}

/**
 * Enlarged view of a client profile photo. Clicking the overlay, pressing Escape
 * or the close button dismisses it.
 */
export function ClientPhotoLightbox({ open, onOpenChange, src, name }: ClientPhotoLightboxProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-auto max-w-none border-0 bg-transparent p-0 shadow-none [&>button]:text-white">
        <DialogTitle className="sr-only">Foto de {name}</DialogTitle>
        <img src={src} alt={name} className="max-h-[85vh] max-w-[90vw] rounded-lg object-contain" />
      </DialogContent>
    </Dialog>
  );
}
